<template>
  <div class="medical-record-exam">
    <div class="border-title text-center">
      <label class="form-label text-bold mb-2">OCT Papila</label>
      <div class="columns">
        <div class="column col-4 text-bold"></div>
        <div class="column col-4 text-bold">OD</div>
        <div class="column col-4 text-bold">OE</div>
      </div>
    </div>
    <div class="border-items">
      <div class="columns">
        <div class="column col-4 form-group centered">Disc. Área</div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.discAreaR"
                   step="0.01" min="0" max="10"
                   placeholder="0,00 - 10,00"
                   data-tabindex="1">
            <span class="input-group-addon">mm</span>
          </div>
        </div>
        <div class="column col-4 form-group">
          <div class="input-group">
            <input type="number" class="form-input text-center"
                   v-model="form.discAreaL"
                   step="0.01" min="0" max="10"
                   placeholder="0,00 - 10,00"
                   data-tabindex="2">
            <span class="input-group-addon">mm</span>
          </div>
        </div>
        <div class="column col-4 form-group centered">Linear CDR</div>
        <div class="column col-4 form-group">
          <input type="number" class="form-input text-center"
                 v-model="form.linearCdrR"
                 step="0.01" min="0" max="1"
                 placeholder="0,00 - 1,00"
                 data-tabindex="1">
        </div>
        <div class="column col-4 form-group">
          <input type="number" class="form-input text-center"
                 v-model="form.linearCdrL"
                 step="0.01" min="0" max="1"
                 placeholder="0,00 - 1,00"
                 data-tabindex="2">
        </div>
        <div class="column col-4 form-group centered">Vertical CDR</div>
        <div class="column col-4 form-group">
          <input type="number" class="form-input text-center"
                 v-model="form.verticalCdrR"
                 step="0.01" min="0" max="1"
                 placeholder="0,00 - 1,00"
                 data-tabindex="1">
        </div>
        <div class="column col-4 form-group">
          <input type="number" class="form-input text-center"
                 v-model="form.verticalCdrL"
                 step="0.01" min="0" max="1"
                 placeholder="0,00 - 1,00"
                 data-tabindex="2">
        </div>
        <template v-if="!triage">
          <div class="column col-4 form-group centered">Template OD</div>
          <div class="column col-8 form-group">
            <select class="form-select" v-model="form.templateR" @change="loadTemplate('R')">
              <option value="">[Selecione]</option>
              <option v-for="template in templates" :key="template.id" :value="template.id">
                {{ template.name }}
              </option>
            </select>
          </div>
          <div class="column col-4 form-group centered">Laudo OD</div>
          <div class="column col-8 form-group">
            <st-editor v-model="form.reportR"></st-editor>
          </div>
          <div class="column col-4 form-group centered">Template OE</div>
          <div class="column col-8 form-group">
            <select class="form-select" v-model="form.templateL" @change="loadTemplate('L')">
              <option value="">[Selecione]</option>
              <option v-for="template in templates" :key="template.id" :value="template.id">
                {{ template.name }}
              </option>
            </select>
          </div>
          <div class="column col-4 form-group centered">Laudo OE</div>
          <div class="column col-8 form-group">
            <st-editor id="professional-signature"
              v-model="form.reportL"></st-editor>
          </div>
        </template>
        <div class="column col-4 form-group centered">Observações</div>
        <div class="column col-8 form-group">
          <input type="text" class="form-input"
                 v-model="form.observations"
                 placeholder="Observações...">
        </div>
      </div>

      <st-entity-file-manager
        v-if="form.id"
        :entity-id="patient.id"
        :origin-id="medicalRecordId"
        :origin-child-id="form.id"
        origin-type="medical_record_exam"
        :key="medicalRecordId"
      />

      <div class="text-center btn-icon btn-icon-left mt-2">
        <button
          type="button"
          class="btn btn-info mr-2"
          :class="{ loading: saving }"
          @click="save"
        ><fa-icon :icon="['fal', 'save']" /> Salvar</button>
        <button
          type="button"
          class="btn btn-gray-outline btn-icon btn-icon-left mr-2"
          @click="$emit('cancel')"
        ><fa-icon :icon="['fal', 'times']" /> Cancelar</button>
        <button
          v-if="!triage"
          type="button"
          class="btn btn-info-outline btn-icon btn-icon-left mr-2"
          :disabled="true"
        ><fa-icon :icon="['fal', 'history']" /> Histórico</button>
        <st-button-report
          v-if="!triage"
          type="pdf"
          label="Imprimir"
          button-class="btn-gray mr-2"
          :route="printUrl"
          :options="[]"
        />
        <button
          type="button"
          class="btn btn-error btn-icon btn-icon-left"
          :class="{ loading: removing }"
          @click="promptRemoval"
        ><fa-icon :icon="['fal', 'trash']" /> Excluir</button>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from './formMixin';
import templateMixin from './templateMixin';

export default {
  mixins: [formMixin, templateMixin],
  data() {
    return {
      form: {
        id: null,
        discAreaR: '',
        discAreaL: '',
        linearCdrR: '',
        linearCdrL: '',
        verticalCdrR: '',
        verticalCdrL: '',
        reportR: '',
        reportL: '',
        templateR: '',
        templateL: '',
        observations: '',
      },
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

</style>
